export default [
  {
    heading: "questionnaire",
    conditions: [0.95, 1],
    questions: [
      {
        id: 1,
        text: "iq_education",
        value: {},
        options: [
          {
            value: { points: 2, text: "iq_education_higher" }
          },
          {
            value: { points: 0, text: "iq_education_secondary" }
          },
          {
            value: { points: -2, text: "iq_education_primary" }
          }
        ]
      },
      {
        id: 2,
        text: "iq_is_education_economic",
        value: {},
        options: [
          {
            value: { points: 3, text: "yes" }
          },
          {
            value: { points: 0, text: "no" }
          }
        ]
      },
      {
        id: 3,
        text: "iq_main_income_source",
        input: {
          label: "iq_main_income_source_label",
          type: "text",
          placeholder: "iq_main_income_source_placeholder",
          required: true,
          hidden: true,
          value: ""
        },
        value: [],
        options: [
          {
            value: { points: 1, text: "employee", showInput: true }
          },
          {
            value: { points: 1, text: "self_employed", showInput: true }
          },
          {
            value: { points: 1, text: "entrepreneur", showInput: true }
          },
          {
            value: { points: -1, text: "student" }
          },
          {
            value: { points: -1, text: "pensioner" }
          },
          {
            value: { points: -3, text: "unemployed" }
          }
        ]
      },
      {
        id: 4,
        text: "iq_politically_exposed_person",
        value: {},
        options: [
          {
            value: { points: 0, text: "yes" }
          },
          {
            value: { points: 0, text: "no" }
          }
        ]
      },
      {
        id: 5,
        text: "iq_watch_financial_markets",
        value: {},
        options: [
          {
            value: { points: 5, text: "daily" }
          },
          {
            value: { points: 3, text: "more_than_weekly" }
          },
          {
            value: { points: 1, text: "less_then_weekly" }
          },
          {
            value: { points: -3, text: "occasionally" }
          }
        ]
      }
    ]
  },
  {
    heading: "account_information",
    conditions: [2, 4],
    questions: [
      {
        id: 6,
        text: "iq_investment_intention",
        multiple: true,
        value: [],
        options: [
          {
            value: { points: 0, text: "asset_appreciation" }
          },
          {
            value: { points: 0, text: "capital_protection" }
          },
          {
            value: { points: 1, text: "investment_income" }
          },
          {
            value: {
              points: 3,
              text: "speculation"
            }
          }
        ]
      },
      {
        id: 7,
        text: "iq_investment_period",
        value: {},
        options: [
          {
            value: {
              points: -3,
              text: "iq_investment_period_very_short"
            }
          },
          {
            value: { points: 2, text: "iq_investment_period_short" }
          },
          {
            value: { points: 3, text: "iq_investment_period_medium" }
          },
          {
            value: { points: 5, text: "iq_investment_period_long" }
          }
        ]
      },
      {
        id: 8,
        text: "iq_accepted_level_of_risk",
        value: {},
        input: null,
        options: [
          {
            value: { points: -3, text: "low_female" }
          },
          {
            value: { points: 0, text: "medium_female" }
          },
          {
            value: { points: 1, text: "high_female" }
          }
        ]
      },
      {
        id: 9,
        text: "iq_expected_return",
        value: {},
        options: [
          {
            value: { points: 0, text: "low_male" }
          },
          {
            value: { points: 1, text: "medium_male" }
          },
          {
            value: { points: 3, text: "high_male" }
          }
        ]
      },
      {
        id: 10,
        text: "iq_stress_scenario",
        values: {},
        options: [
          {
            value: {
              points: -2,
              text: "iq_stress_scenario_immediate_sell"
            }
          },
          {
            value: {
              points: 0,
              text: "iq_stress_scenario_wait_then_sell"
            }
          },
          {
            value: {
              points: 3,
              text: "iq_stress_scenario_keep_calm"
            }
          },
          {
            value: {
              points: 3,
              text: "iq_stress_scenario_increase_investment"
            }
          }
        ]
      },
      {
        id: 11,
        text: "iq_loss_of_planned_investment",
        value: {},
        options: [
          {
            value: {
              points: 0,
              text: "iq_loss_of_planned_investment_without_impact"
            }
          },
          {
            value: {
              points: -1,
              text: "iq_loss_of_planned_investment_minor_impact"
            }
          },
          {
            value: {
              points: -3,
              text: "iq_loss_of_planned_investment_major_impact"
            }
          }
        ]
      }
    ]
  },
  {
    heading: "income_and_assets_value",
    conditions: [-2, 0],
    questions: [
      {
        id: 12,
        text: "iq_assets_value",
        value: {},
        options: [
          {
            value: { points: 3, text: "iq_assets_value_high" }
          },
          {
            value: { points: 2, text: "iq_assets_value_medium" }
          },
          {
            value: { points: 0, text: "iq_assets_value_low" }
          }
        ]
      },
      {
        id: 13,
        text: "iq_invested_amount_is",
        value: {},
        options: [
          {
            value: {
              points: 0,
              text: "iq_invested_amount_is_my_capital"
            }
          },
          {
            value: {
              points: -8,
              text: "iq_invested_amount_is_loan"
            }
          },
          {
            value: {
              points: -8,
              text: "iq_invested_amount_is_loan_from_another_person"
            }
          }
        ]
      },
      {
        id: 14,
        text: "iq_yearly_income",
        value: {},
        options: [
          {
            value: { points: 5, text: "iq_yearly_income_high" }
          },
          {
            value: { points: 2, text: "iq_yearly_income_medium" }
          },
          {
            value: { points: 1, text: "iq_yearly_income_low" }
          },
          {
            value: { points: 0, text: "less" }
          }
        ]
      }
    ]
  },
  {
    heading: "investment_knowledge_and_experience",
    conditions: [1, 2],
    questions: [
      {
        id: 15,
        text: "iq_experience_with_financial_markets",
        value: {},
        options: [
          {
            value: {
              points: 0,
              text:
                "iq_experience_with_financial_markets_occasional_trading_small_amount"
            }
          },
          {
            value: {
              points: 1,
              text:
                "iq_experience_with_financial_markets_occasional_trading_large_amount"
            }
          },
          {
            value: {
              points: 1,
              text:
                "iq_experience_with_financial_markets_regular_trading_small_amount"
            }
          },
          {
            value: {
              points: 3,
              text:
                "iq_experience_with_financial_markets_regular_trading_large_amount"
            }
          }
        ]
      },
      {
        id: 16,
        multiple: true,
        text: "iq_known_securities",
        value: [],
        options: [
          {
            value: {
              points: 1,
              text: "funds"
            }
          },
          {
            value: { points: 2, text: "shares" }
          },
          {
            value: { points: 1, text: "bonds" }
          },
          {
            value: {
              points: 3,
              text: "certificates_and_etf"
            }
          },
          {
            value: {
              points: 5,
              text: "derivatives"
            }
          },
          {
            value: { points: -2, text: "dunno" }
          }
        ]
      },
      {
        id: 17,
        multiple: true,
        text: "iq_previous_years_investment",
        value: [],
        options: [
          {
            value: {
              points: 1,
              text: "funds"
            }
          },
          {
            value: {
              points: 3,
              text: "shares_and_etf_and_certificates"
            }
          },
          {
            value: { points: 1, text: "bonds" }
          },
          {
            value: { points: 5, text: "derivatives" }
          }
        ]
      }
    ]
  },
  {
    heading: "verification_questions",
    conditions: [1, 2],
    questions: [
      {
        id: 18,
        text: "iq_eminent_is",
        value: {},
        options: [
          {
            value: { points: -0.5, text: "iq_eminent_is_bank" }
          },
          {
            value: { points: -0.5, text: "iq_eminent_is_creditor" }
          },
          {
            value: { points: 3, text: "iq_eminent_is_eminent" }
          }
        ]
      },
      {
        id: 19,
        text: "iq_diversification_is",
        value: {},
        options: [
          {
            value: {
              points: -0.5,
              text: "iq_diversification_is_reinvestment"
            }
          },
          {
            value: {
              points: 2,
              text: "iq_diversification_is_diversification"
            }
          },
          {
            value: {
              points: -0.5,
              text: "iq_diversification_is_return_split"
            }
          }
        ]
      },
      {
        id: 20,
        text: "iq_share_is",
        value: {},
        options: [
          {
            value: { points: -0.5, text: "iq_share_is_guarantee" }
          },
          {
            value: { points: -0.5, text: "iq_share_is_not_tradeble" }
          },
          {
            value: {
              points: 2,
              text: "iq_share_is_share"
            }
          }
        ]
      },
      {
        id: 21,
        text: "iq_important_thing_about_bond_is",
        value: {},
        options: [
          {
            value: {
              points: -1,
              text:
                "iq_important_thing_about_bond_is_creditworthiness_of_bondholder"
            }
          },
          {
            value: {
              points: -1,
              text: "iq_important_thing_about_bond_is_invested_amount"
            }
          },
          {
            value: {
              points: 1,
              text:
                "iq_important_thing_about_bond_is_creditworthiness_of_emitent"
            }
          }
        ]
      }
    ]
  }
];
